import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { MonitoringService } from '@services/monitoring.service';
import { MonitoringFilters } from '@classes/monitoring/monitoring-filters';
import { MonitoringFilterItem } from '@classes/monitoring/monitoring-filter-item';
import { MonitoringResults } from '@classes/monitoring/monitoring-results';

@Component({
  selector: 'app-monitoring',
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.scss']
})
export class MonitoringComponent implements OnInit, OnDestroy {

    filters = new MonitoringFilters();
    results = new MonitoringResults();

    isProcessing = false;

    private subscription: Subscription;

    constructor (private monitoringService: MonitoringService) {}

    ngOnInit (): void {
        this.loadFilters();
    }
    ngOnDestroy (): void {
        this.subscription.unsubscribe();
    }

    onSelectionChange (filters: MonitoringFilters): void {
        this.filters = filters.clone();
        this.loadResults();
    }

    private loadFilters () {
        this.isProcessing = true;
        this.subscription = this.monitoringService
            .getFilters()
            .subscribe(items => this.updateFilters(items));
    }
    private updateFilters (items: MonitoringFilterItem[]) {
        this.filters.items = items ?? [];
        this.filters.items.forEach(item => item.isSelected = true);
        this.filters.items.forEach(item => item.isVisible  = true);
        this.filters = this.filters.clone();
        this.isProcessing = false;
    }

    private loadResults () {
        this.isProcessing = true;
        this.subscription = this.monitoringService
            .getResults(this.filters)
            .subscribe(results => this.updateResults(results));
    }
    private updateResults (results: MonitoringResults) {
        this.results = results ?? new MonitoringResults();
        this.isProcessing = false;
    }

}
